import { createFileRoute, Link, Outlet, redirect } from '@tanstack/react-router'
import { Box, Text, Button, Card, Flex, ScrollArea } from '@radix-ui/themes'
import classNames from 'classnames'
import { useState } from 'react'
import { LuAlignJustify, LuX } from 'react-icons/lu'

export const Route = createFileRoute('/plugins/eiffage-scans')({
  beforeLoad: async ({ context }) => {
    if (!context.session || import.meta.env.DEV || import.meta.env.VITE_ENV === 'preview') {
      return
    }
    if (context.org.id !== '05cc534c-4b0a-42c4-8b39-451a6c72d010') {
      throw redirect({
        to: '/sites'
      })
    }
  },
  component: RouteComponent
})

function RouteComponent() {
  const [menuopen, setMenuOpen] = useState(false)

  return (
    <Box p="3" m={'auto'} className="w-full lg:w-[80%] xl:w-[70%] max-w-[1200px] h-[100vh]">
      <Card className={classNames('w-full h-full p-0', { 'h-[full]': menuopen })}>
        <Flex
          justify="between"
          align="center"
          className={classNames('border-b-[1px] border-gray-6 h-[100px] p-5')}
        >
          <img
            src="https://www.eiffage.com/files/live/sites/eiffagev2/files/Home/logo-eiffage.svg"
            alt="Eiffage Logo"
            className="h-6"
          />

          <Button
            variant="ghost"
            color="gray"
            className="rounded-full h-10 w-10"
            onClick={() => setMenuOpen(!menuopen)}
          >
            {menuopen ? <LuX size={26} color="gray" /> : <LuAlignJustify size={26} color="gray" />}
          </Button>
        </Flex>
        <Flex
          direction={'column'}
          className={classNames(
            'ml-[1px] absolute bg-white dark:bg-slate-800 w-[calc(100%-2px)] z-10 overflow-hidden transition-[min-height] duration-150 ease-out rounded-b-lg border-b-[1px] ',
            menuopen ? 'min-h-[calc(100%-100px)] border-gray-7' : 'min-h-0 h-0 border-transparent'
          )}
        >
          <Link
            onClick={() => setMenuOpen(false)}
            to={'/plugins/eiffage-scans'}
            className="border-b-[1px] border-gray-7 flex items-center py-4 px-8 hover:bg-gray-2"
          >
            <Text size="3" weight="medium" color="gray">
              Acceuil à la numérisation de carnets
            </Text>
          </Link>
          <Link
            onClick={() => setMenuOpen(false)}
            to={'/sites'}
            className="border-b-[1px] border-gray-7 flex items-center py-4 px-8  hover:bg-gray-2"
          >
            <Text size="3" weight="medium" color="gray">
              Retour à Willie
            </Text>
          </Link>
        </Flex>
        <ScrollArea className="h-[calc(100vh-7rem)]">
          <Flex align={'center'} height={'100%'} width={'100%'} className="min-w-[100%]" justify={'center'} p="5">
            <Outlet />
          </Flex>
        </ScrollArea>
      </Card>
    </Box>
  )
}
